import Home from "./pages/home";
import "./styles/home.scss";
import { Route, Routes } from "react-router-dom";
import Layout from "./components/Layout";
import Voting from "./pages/voting";
import { Web3Provider } from "./provider/Web3Provider";

function App() {
  return (
    <Web3Provider>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="/voting/:proposalId" element={<Voting />} />
        </Route>
      </Routes>
    </Web3Provider>
  );
}

export default App;
